import React, { useState } from "react";
import authService from "../services/authService";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const result = await authService.login(username, password);
            
            if (result.success) {
                setSuccess("Login successful! Redirecting to dashboard...");
                console.log("Login successful, redirecting to dashboard...");
                // Use React Router navigation instead of window.location.href
                setTimeout(() => {
                    navigate("/dashboard");
                }, 1000); // 1 second delay to show success message
            } else {
                setError(result.message || "Login failed");
            }
        } catch (error) {
            setError("Login failed. Please try again.");
            console.error("Login error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
    <div className="container min-vh-100 d-flex">
      <div className="row w-100 justify-content-center align-self-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-5 text-white">
                <h1 className="header-name pb-5">Login</h1>
                
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                
                {success && (
                    <div className="alert alert-success" role="alert">
                        {success}
                    </div>
                )}
                
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 16 }}>
                        <label className="subtext">
                            Username:
                            <input
                                className="form-control"
                                type="text"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                style={{ width: "100%", padding: 8, marginTop: 4 }}
                                required
                                disabled={loading}
                            />
                        </label>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <label className="subtext">
                            Password:
                            <input
                                className="form-control"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                style={{ width: "100%", padding: 8, marginTop: 4 }}
                                required
                                disabled={loading}
                            />
                        </label>
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-secondary"
                        disabled={loading}
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
            </div>
        </div>
    );
};

export default AdminLogin;
